import { getDefaultValue } from 'src/components/shared/form-elements';
import { FormInput } from '../../../../../@types';
import { PrivacyFormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';

export const usePrivacyFormFieldsConfig = (intl: IntlShape) => {
  const privacyFormFieldsConfig: Record<keyof PrivacyFormFields, FormInput> = {
    requestType: {
      fieldName: 'requestType',
      label: '',
      type: 'radio',
      options: [
        {
          value: 'InzagePersoonsgegevens',
          label: intl.formatMessage({
            id: 'field.requestType.label.inzagePersoonsgegevens',
            defaultMessage: 'Inzage in de eigen persoonsgegevens'
          })
        },
        {
          value: 'RectificatiePersoonsgegevens',
          label: intl.formatMessage({
            id: 'field.requestType.label.rectificatiePersoonsgegevens',
            defaultMessage: 'Rectificatie van de eigen persoonsgegevens'
          })
        },
        {
          value: 'Vergetelheid',
          label: intl.formatMessage({
            id: 'field.requestType.label.vergetelheid',
            defaultMessage:
              'Vergetelheid (gegevenswissing, verwijdering, het recht om vergeten te worden)'
          })
        },
        {
          value: 'BezwaarMarketingdoeleinden',
          label: intl.formatMessage({
            id: 'field.requestType.label.bezwaarMarketingdoeleinden',
            defaultMessage: 'Bezwaar maken tegen het gebruik voor marketingdoeleinden'
          })
        }
      ],
      defaultValue: getDefaultValue('BezwaarMarketingdoeleinden')
    },
    requestReason: {
      fieldName: 'requestReason',
      label: '',
      type: 'text',
      hint: intl.formatMessage({
        id: 'field.requestReason.hint',
        defaultMessage:
          'Dit formulier is niet bedoeld voor het doorgeven van een adreswijziging of overlijden. Neem hiervoor contact op met je hypotheekadviseur.'
      }),
      defaultValue: getDefaultValue('requestReason')
    },
    firstname: {
      fieldName: 'firstname',
      label: intl.formatMessage({
        id: 'field.firstname.label',
        defaultMessage: 'Voornaam'
      }),
      type: 'text',
      defaultValue: getDefaultValue('firstname')
    },
    lastname: {
      fieldName: 'lastname',
      label: intl.formatMessage({
        id: 'field.lastname.label',
        defaultMessage: 'Achternaam'
      }),
      type: 'text',
      defaultValue: getDefaultValue('lastname')
    },
    street: {
      fieldName: 'street',
      label: intl.formatMessage({
        id: 'field.street.label',
        defaultMessage: 'Straat'
      }),
      type: 'text',
      defaultValue: getDefaultValue('street')
    },
    houseNumber: {
      fieldName: 'houseNumber',
      label: intl.formatMessage({
        id: 'field.houseNumber.label',
        defaultMessage: 'Huisnummer'
      }),
      type: 'text',
      defaultValue: getDefaultValue('153')
    },
    houseNumberAddition: {
      fieldName: 'houseNumberAddition',
      label: intl.formatMessage({
        id: 'field.houseNumberAddition.label',
        defaultMessage: 'Toevoeging'
      }),
      type: 'text',
      defaultValue: getDefaultValue('B')
    },
    postalCode: {
      fieldName: 'postalCode',
      label: intl.formatMessage({
        id: 'field.postalCode.label',
        defaultMessage: 'Postcode'
      }),
      type: 'text',
      defaultValue: getDefaultValue('1034 BA')
    },
    city: {
      fieldName: 'city',
      label: intl.formatMessage({
        id: 'field.city.label',
        defaultMessage: 'Plaatsnaam'
      }),
      type: 'text',
      defaultValue: getDefaultValue('city')
    },
    emailKnown: {
      fieldName: 'emailKnown',
      label: intl.formatMessage({
        id: 'field.emailKnown.label',
        defaultMessage: 'E-mailadres dat bij ons bekend is'
      }),
      type: 'text',
      defaultValue: getDefaultValue('vincent.bunjes@deptagency.com')
    },
    emailKnownNotContact: {
      fieldName: 'emailKnownNotContact',
      label: intl.formatMessage({
        id: 'field.emailKnownNotContact.label',
        defaultMessage: 'Is dit ook het e-mailadres waarop we je kunnen bereiken?'
      }),
      type: 'radio',
      layout: 'horizontal',
      options: [
        {
          value: 'ja',
          label: intl.formatMessage({
            id: 'field.emailKnownNotContact.option.yes',
            defaultMessage: 'Ja'
          })
        },
        {
          value: 'nee',
          label: intl.formatMessage({
            id: 'field.emailKnownNotContact.option.no',
            defaultMessage: 'Nee'
          })
        }
      ],
      defaultValue: getDefaultValue('Ja')
    },
    emailContact: {
      fieldName: 'emailContact',
      label: intl.formatMessage({
        id: 'field.emailContact.label',
        defaultMessage: 'E-mail adres voor contact'
      }),
      type: 'text',
      defaultValue: getDefaultValue('vincent.bunjes+1@deptagency.com')
    }
  };
  return privacyFormFieldsConfig;
};
